import React from "react";
import { Container } from "./styles/Loader";

const Loader: React.FC<{ fadeOut: boolean }> = ({ fadeOut, ...restProps }) => (
  <Container fadeOut={!fadeOut} {...restProps}>
    <div />
    <div />
    <div />
  </Container>
);

export default Loader;
